import { render, staticRenderFns } from "./reset-passwords.vue?vue&type=template&id=933e5dae&scoped=true&"
import script from "./reset-passwords.vue?vue&type=script&lang=js&"
export * from "./reset-passwords.vue?vue&type=script&lang=js&"
import style0 from "./reset-passwords.vue?vue&type=style&index=0&id=933e5dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933e5dae",
  null
  
)

export default component.exports